module.exports = __webpack_public_path__ + "img/blueprint_logo.4943b4a5.png";